import { useDroppable } from '@dnd-kit/core';
import { ReactNode } from 'react';

interface DroppableCellProps {
  id: string;
  date: Date;
  time?: string;
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export function DroppableCell({ id, date, time, children, className = '', onClick }: DroppableCellProps) {
  const { isOver, setNodeRef } = useDroppable({
    id,
    data: { date, time },
  });

  return (
    <div
      ref={setNodeRef}
      onClick={onClick}
      className={`${className} ${isOver ? 'droppable-over' : ''}`}
    >
      {children}
    </div>
  );
}
